import { render, staticRenderFns } from "./StepperBusiness.vue?vue&type=template&id=2236a451&scoped=true&"
import script from "./StepperBusiness.vue?vue&type=script&lang=js&"
export * from "./StepperBusiness.vue?vue&type=script&lang=js&"
import style0 from "./StepperBusiness.vue?vue&type=style&index=0&id=2236a451&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2236a451",
  null
  
)

export default component.exports